import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import { PRODUCT_TYPES, STATUSES } from '../../constants';
import { callSelectorByProductType } from './general-utils';
import { getDisplayStatus as bankingGetDisplayStatus } from '../banking';
/**
 * Get the status of the entity
 * NOTE: does not support `MORTG`
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {string}                   The status [ACTIVE,INACTIVE]
 */

export var getStatus = function getStatus(marketplaceEntity) {
  return callSelectorByProductType(marketplaceEntity, _defineProperty({}, PRODUCT_TYPES.BANKING, bankingGetDisplayStatus), function (entity) {
    return _get(entity, 'status');
  });
};
/**
 * Get the active status of the entity
 * Returns `true` if entity is active
 *
 * @param  {Object} marketplaceEntity The marketplace entity
 *
 * @return {boolean}
 */

export var isActive = function isActive(marketplaceEntity) {
  return getStatus(marketplaceEntity) === STATUSES.ACTIVE;
};